// extracted by mini-css-extract-plugin
export default {"resetButton":"RJGnTWV","warning":"FNdDfyz","documentControl":"kV4xQGK"};